"use strict";
/*
 * Escapes `"` charachters from string
*/
function escapeString(str) {
    return str.replace('"', '\"');
}
/*
 * Determines if a value is an object
*/
function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object');
}
exports.isObject = isObject;
/*
 * Gets constructor name of an object.
 * From http://stackoverflow.com/a/332429
 *
*/
function getObjectName(object) {
    if (object === undefined) {
        return '';
    }
    if (object === null) {
        return 'Object';
    }
    if (typeof object === 'object' && !object.constructor) {
        return 'Object';
    }
    var funcNameRegex = /function (.{1,})\(/;
    var results = (funcNameRegex).exec((object).constructor.toString());
    if (results && results.length > 1) {
        return results[1];
    }
    else {
        return '';
    }
}
exports.getObjectName = getObjectName;
/*
 * Gets type of an object. Returns "null" for null objects
*/
function getType(object) {
    if (object === null) {
        return 'null';
    }
    return typeof object;
}
exports.getType = getType;
/*
 * Generates inline preview for a JavaScript object based on a value
*/
function getValuePreview(object, value) {
    var type = getType(object);
    if (type === 'null' || type === 'undefined') {
        return type;
    }
    if (type === 'string') {
        value = '"' + escapeString(value) + '"';
    }
    if (type === 'function') {
        // Remove content of the function
        return object.toString()
            .replace(/[\r\n]/g, '')
            .replace(/\{.*\}/, '') + '{…}';
    }
    return value;
}
exports.getValuePreview = getValuePreview;
/*
 * Generates inline preview for a JavaScript object
*/
function getPreview(object) {
    var value = '';
    if (isObject(object)) {
        value = getObjectName(object);
        if (Array.isArray(object))
            value += '[' + object.length + ']';
    }
    else {
        value = getValuePreview(object, object);
    }
    return value;
}
exports.getPreview = getPreview;
/*
 * Generates a prefixed CSS class name
*/
function cssClass(className) {
    return "json-formatter-" + className;
}
exports.cssClass = cssClass;
/*
  * Creates a new DOM element wiht given type and class
  * TODO: move me to helpers
*/
function createElement(type, className, content) {
    var el = document.createElement(type);
    if (className) {
        el.classList.add(cssClass(className));
    }
    if (content !== undefined) {
        if (content instanceof Node) {
            el.appendChild(content);
        }
        else {
            el.appendChild(document.createTextNode(String(content)));
        }
    }
    return el;
}
exports.createElement = createElement;



/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers.ts
 ** module id = 6
 ** module chunks = 0
 **/